import React, { CSSProperties, useMemo } from "react";
import { PropsWithChildren, isValidElement } from "react";

export type TableColumn = {
  name: string;
  weight?: number;
};

export const useTableGridStyle = (columns: TableColumn[]) => {
  const style = useMemo<CSSProperties>(
    () => ({
      gridTemplateColumns: columns.map(c => `${c.weight || 1}fr`).join(" ")
    }),
    [columns]
  );

  return style;
};

const TableContainer = ({
  columns,
  children,
  className,
  noScroll
}: PropsWithChildren<{
  columns: TableColumn[];
  className?: string;
  noScroll?: boolean;
}>) => {
  const style = useTableGridStyle(columns);

  const rows = useMemo(
    () =>
      React.Children.map(children, child => {
        if (isValidElement(child) && "props" in child) {
          return React.createElement(child.type, {
            ...child.props,
            style
          });
        }
      }),
    [children, style]
  );

  return (
    <section className={"rounded-lg shadow-table " + className}>
      <header
        className="sticky top-0 z-10 grid rounded-t-lg py-4 pl-11 text-[15px] font-normal text-white bg-[#010D2C]"
        style={style}
      >
        {columns.map((column, index) => (
          <p key={index}>
            {column.name}
          </p>
        ))}
      </header>

      <div className={noScroll ? "" : "max-h-[calc(5*4rem)] overflow-y-auto"}>{rows}</div>
    </section>
  );
};

export default TableContainer;
